import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import { LegalH2 as H2, LegalP as P, LegalUL as UL } from './_legalHelpers';

export default function Grievance() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const effectiveDate = new Date().toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <div data-testid="grievance-page" className="bg-white min-h-screen">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link to="/" data-testid="grievance-breadcrumb"
            className="inline-flex items-center text-[11px] font-semibold uppercase tracking-[0.2em] text-[#673c96]/70 hover:text-[#f37721] transition-colors mb-8"
            style={{ fontFamily: 'Montserrat, sans-serif' }}>
            ← Back to Home
          </Link>

          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#311b52] mb-3"
            style={{ fontFamily: 'Poppins, sans-serif' }}>
            Grievance & Data Rights
          </h1>

          <div className="flex flex-col gap-1 mb-10 pb-10 border-b border-[#673c96]/10">
            <p className="text-[13px] text-[#673c96]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <span className="font-semibold">Effective Date:</span> {effectiveDate}
            </p>
            <p className="text-[13px] text-[#673c96]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <span className="font-semibold">Statute:</span> Digital Personal Data Protection Act, 2023 (DPDP)
            </p>
          </div>

          <H2>Grievance Officer</H2>
          <P>
            Under the Digital Personal Data Protection Act, 2023, the following officer is responsible for handling privacy, data-rights and service complaints from BookMyJab users.
          </P>
          <P>
            <strong>BookMyJab Grievance Officer</strong><br />
            Email: <a href="mailto:bookmyjab@gmail.com" className="text-[#f37721] hover:underline font-medium" data-testid="grievance-email">bookmyjab@gmail.com</a><br />
            Phone / WhatsApp: <a href="tel:+919873554343" className="text-[#f37721] hover:underline font-medium" data-testid="grievance-phone">+91 9873 55 4343</a><br />
            Service area: Gurgaon, Haryana, India
          </P>
          <P>
            You may contact the Grievance Officer for any privacy query, data correction, data access (download your data), withdrawal of consent, account deletion, complaint or service issue. You can also use the in-app Support option on the booking, tracking and confirmation screens.
          </P>

          <H2>Your Rights Under DPDP</H2>
          <P>You have the right to:</P>
          <UL>
            <li><strong>Access</strong> a copy of the personal data we hold about you.</li>
            <li><strong>Correct or update</strong> inaccurate or incomplete data (e.g. your name, contact details, family member records).</li>
            <li><strong>Request deletion / erasure</strong> of your account and personal data, subject to retention required by Indian medical, tax and consumer-protection law.</li>
            <li><strong>Withdraw consent</strong> for further processing. Withdrawal may stop us from delivering further service, issuing certificates or processing refunds.</li>
            <li><strong>Nominate</strong> another individual to exercise your rights in the event of death or incapacity.</li>
            <li><strong>Raise a grievance</strong> with our Grievance Officer (above).</li>
          </UL>

          <H2>How to Submit a Request</H2>
          <P>
            Until the in-app self-service flow is fully available for your account, please email <a href="mailto:bookmyjab@gmail.com" className="text-[#f37721] hover:underline font-medium">bookmyjab@gmail.com</a> with:
          </P>
          <UL>
            <li>the registered mobile number / email on your BookMyJab account,</li>
            <li>the nature of your request (access / correction / deletion / withdrawal / grievance), and</li>
            <li>any supporting context (booking ID, family member name, screenshot).</li>
          </UL>

          <H2>Response Timeline</H2>
          <P>
            We aim to acknowledge privacy and data-rights requests within <strong>72 hours</strong> of receipt and resolve valid grievances within a reasonable period as per applicable Indian law and operational verification.
          </P>

          <H2>Escalation</H2>
          <P>
            If you are not satisfied with our response, you may approach the Data Protection Board of India established under the DPDP Act, or any other competent authority under applicable Indian law.
          </P>
        </div>
      </main>
      <Footer />
    </div>
  );
}
